import Vue from 'vue'

const emailListAction = {
    ADD: 'add',
    REMOVE: 'remove',
    SET: 'set'
}

export default {

    create(name, surveyPeriodId) {
        let data = {
            name,
        };

        return new Promise((resolve, reject) => {
          if (!surveyPeriodId || surveyPeriodId <= 0 || !Number.isInteger(surveyPeriodId)) {
            reject("Invalid surveyPeriod.id given")
            return;
          }

          data.surveyPeriodId = surveyPeriodId;

          Vue.http.post("super-admin/invitation-manager", data).then(
            response => {
                resolve(response.body.data);
            },
            error => {
                reject(error);
            }
          );
        });
    },

    delete(id) {
        // Validate id
        if (!id || id <= 0 || !Number.isInteger(id)) {
            return null;
        }

        return new Promise((resolve, reject) => {
            Vue.http.delete("super-admin/invitation-manager/" + id).then(
                response => {
                    resolve(response.body.data);
                },
                error => {
                    reject(error);
                }
              );
        });
    },

    modifyEmails: function (campaignId, action, emails) {
      if (Object.values(emailListAction).indexOf(action) == -1) {
        return null;
      }

      return new Promise((resolve, reject) => {
        let data = {
          emails: emails
        };
        Vue.http.post(
          "super-admin/invitation-manager/" + action + "-emails/" + campaignId,
          data
        ).then(
          response => {
            resolve(response.body.data);
          },
          error => {
            reject("Error modifying invitation campaign email list");
          }
        );
      });
    },

    addEmails(id, emails) {
        return this.modifyEmails(id, emailListAction.ADD, emails);
    },

    removeEmails(id, emails) {
        return this.modifyEmails(id, emailListAction.REMOVE, emails);
    },

    synchronize(campaignId) {
        return new Promise((resolve, reject) => {
            Vue.http.post('super-admin/invitation-manager/' + campaignId + '/update-syncs', {}).then(
                response => {
                    resolve(response.body.data);
                },
                error => {
                    reject(error);
                }
              );
        });
    },

}